import styled from 'styled-components';

// @ts-expect-error No types given for file
import RequestStatus from 'developer-docs-shared-components/lib/models/RequestStatus';
import LayoutPublic from '../components/LayoutPublic';
import Article from '../components/Article';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SecondaryNav from '../components/SecondaryNav';
import { MOBILE_MENU_BREAKPOINT, mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import GuidesLandingPage from '../components/landingPages/guides';
import ApiLandingPage from '../components/landingPages/api';
import { useLocation } from 'react-router-dom';
import { proxiedSubdomainBasePath } from 'developer-docs-shared-components/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
// Does not have a ToC, so reclaiming that space.
const StyledArticle = styled(Article).withConfig({
  displayName: "LandingPage__StyledArticle",
  componentId: "sc-13nz0um-0"
})(["padding-right:32px;&&{width:100%;}", "{padding-right:0;}h1,h2{margin-bottom:32px;}"], mediaQueries.belowWidth(MOBILE_MENU_BREAKPOINT));
function LandingPage({
  pageType,
  secondaryNavConfig
}) {
  const {
    pathname
  } = useLocation();
  const [, primaryDir, secondaryDir] = pathname.replace(proxiedSubdomainBasePath, '').split('/');
  const computedPath = `/${primaryDir}/${secondaryDir}`;

  // TODO: For straight MDX docs, no real chance of not succeeding.
  const renderError = () => {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      type: "notFound",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.notFound.header"
      })
    });
  };
  const landingPageComponentMap = {
    '/reference/api': /*#__PURE__*/_jsx(ApiLandingPage, {}),
    '/guides/api': /*#__PURE__*/_jsx(GuidesLandingPage, {})
  };
  return /*#__PURE__*/_jsx(LayoutPublic, {
    disableLoadingState: true,
    loadingStatuses: [RequestStatus.succeeded],
    maxContentWidth: 1200,
    pageId: "LANDING",
    renderError: renderError,
    sideNavComponent: /*#__PURE__*/_jsx(SecondaryNav, {
      navConfig: secondaryNavConfig
    }),
    footerWidth: "full",
    children: /*#__PURE__*/_jsx(StyledArticle, {
      "data-test-id": `${pageType}_LANDING_PAGE`,
      "data-layout": "2-column-wide-right",
      children: landingPageComponentMap[computedPath]
    })
  });
}
export default LandingPage;